import { useQuery } from '@apollo/client';
import type { DealProviderConfig } from '@openx/components-deal/lib/utils/context/DealContext';
import type { DealsListStoreProps } from '@openx/components-deal/lib/utils/context/DealHookTypes';
import type { ListDealBase, OAListDeal } from '@openx/types/deal';
import { GetDealsListDocument } from '../../../graphql/query/deals/GetDealsList.generated';
import type { DealsQueryCriteria } from '../../../modules/deals/DealsList/types';
import { buildDealsQueryString } from './buildDealsQueryString';

export const useDealsFetch: DealProviderConfig['useDealsFetch'] = <T extends ListDealBase = OAListDeal>(
  queryCrit: DealsQueryCriteria | undefined
): DealsListStoreProps<T> => {
  const queryString = buildDealsQueryString(queryCrit);

  const { loading, error, data } = useQuery(GetDealsListDocument, {
    variables: { queryString },
  });

  const dealsList = data?.deals?.objects?.map(dealRaw => ({
    ...dealRaw,
    _package: {
      audience: dealRaw._package?.audience ?? null,
      audience_id: dealRaw._package?.audience_id ?? null,
    },
    deal_id: dealRaw.exchange_deal_id,
    name: dealRaw.name ?? '',
    uid: dealRaw.exchange_uid ?? '',
  }));

  return {
    dealsList: dealsList as unknown as T[],
    error,
    loading,
  };
};
